import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <ContactSection />
        <AboutSection />
        <TopicsSection />
        <MediaSection />
        <AppSection />
        <FaqSection />
        <FeaturesSection />
        <CarouselSection />
        <UpdatesSection />
        <CardsSection />
        <CommentsSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}